import { IEquipoModeloOperadorCommand } from "../../Interfaces/auxiliar/IOperador";
import { Ifilter } from "../../Interfaces/filter";
import { fetchListVerificacion } from "../http-common";

const EquipoModeloOperadorServiceLine = "EquipoModeloOperador";


const ListarRelaciones = (request: Ifilter) => {
   return fetchListVerificacion.post(`${EquipoModeloOperadorServiceLine}/ListarRelaciones`, request);
};
const Crear = (request: IEquipoModeloOperadorCommand) => {
   return fetchListVerificacion.post(`${EquipoModeloOperadorServiceLine}/CrearRelacion`, request);
};

const Eliminar = (request: IEquipoModeloOperadorCommand) => {
   return fetchListVerificacion.post(`${EquipoModeloOperadorServiceLine}/EliminarRelacion`,request);
}
const EquipoModeloOperadorService = {
    ListarRelaciones,Crear,Eliminar
}
export { EquipoModeloOperadorService };